import { useEffect, useState } from "react";
import Loader from "../../../components/loader";
import { projectStatus } from "../../../utils/data";
import { useDispatch, useSelector } from "react-redux";
import HireTalentLayout from "../../../layouts/HireTalentLayout";
import Projects from "../../../components/pages/hire-talent/Projects";
import AddProject from "../../../components/Modals/common/project/AddEditProject";
import RecommendedFreelancer from "../../../components/pages/hire-talent/RecommendedFreelancer";
import {
  addProjectDetails,
  fetchMyProjects,
  fetchRecommendedHireTalentMactching,
} from "../../../redux/features/hire-talent/actions/projectAction";
import ProjectDetails from "../../../components/Modals/common/project/ProjectDetails";
import {
  setIsInvite,
  setIsViewProjectDetails,
} from "../../../redux/features/hire-talent/reducers/projectReducer";
import MarkAsCompleteModal from "../../../components/Modals/hire-talent/MarkAsCompleteModal";
import { SocketBootstrap } from "../../../components/chat/SocketBootstrap";
import { setActiveChat } from "../../../redux/features/chat/chatSlice";

const MyProjects = () => {
  const dispatch = useDispatch();
  const tabs = [
    {
      label: "All Projects",
      value: "all",
    },
    ...projectStatus,
  ];

  const { projectList, isLoading, isViewProjectDetails, isInvite } =
    useSelector((state) => state?.hireTalent?.project);

  const [activeTab, setActiveTab] = useState(tabs[0].value);
  const [isAddProject, setIsAddProject] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [selectProject, setSelectProject] = useState("");

  useEffect(() => {
    setSelectProject('')
    dispatch(fetchMyProjects());

  }, []);

  useEffect(() => {
    if (projectList[activeTab]?.length > 0) {
      setSelectProject(projectList[activeTab][0]?.id ?? "");
    } else {
      setSelectProject("");
    }
  }, [projectList, activeTab]);

  useEffect(() => {
    if (selectProject) {
      dispatch(fetchRecommendedHireTalentMactching({ payload: selectProject }));
    }
  }, [selectProject]);

  const handleEditAddroject = (values) => {
    const callback = (response) => {
      setIsAddProject(false);
      dispatch(fetchMyProjects());
    };
    dispatch(addProjectDetails({ payload: values, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <HireTalentLayout>
        <SocketBootstrap role="hire-talent" />
        <div className="ct_px_40">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="d-flex align-items-center gap-3 justify-content-between mb-3 ct_mt_32 ct_flex_col_991 pb-4 pb-lg-0 "
                  style={{ borderBottom: "1px solid #ccc" }}
                >
                  <div>
                    <ul class="ct_table_filter border-0 ">
                      {tabs?.map((item, index) => (
                        <li
                          onClick={() => setActiveTab(item?.value)}
                          class={`ct_cursor_pointer ${activeTab == item?.value ? "active" : ""
                            }`}
                        >
                          {item?.label}{" "}
                          {`(${projectList[item?.value]?.length || 0})`}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div
                    className="d-flex align-items-center gap-3 ct_flex_col_767 ct_w_100_767 pt-3 pt-lg-0"
                    style={{ marginTop: "-10px" }}
                  >
                    <button
                      className="ct_yellow_btn ct_white_nowrap"
                      onClick={() => setIsAddProject(true)}
                    >
                      Add New Project
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row ct_mt_30">
              <div className="col-xl-11">
                <Projects
                  activeTab={activeTab}
                  setIsSuccess={setIsSuccess}
                  isSuccess={isSuccess}
                  selectProject={selectProject}
                  setSelectProject={setSelectProject}
                />
                {activeTab != "completed" &&
                  activeTab != "dismissed" &&
                  Array.isArray(projectList?.[activeTab]) &&
                  projectList[activeTab].length > 0 && (
                    <RecommendedFreelancer
                      selectProject={selectProject}
                      setSelectProject={setSelectProject}
                    />
                  )}
              </div>
            </div>
            {isSuccess && (
              <MarkAsCompleteModal onClose={() => setIsSuccess(false)} />
            )}
          </div>
        </div>
        {/* Add new project modal S */}
        {isAddProject && (
          <AddProject
            onClose={() => setIsAddProject(false)}
            isAdmin={false}
            handleEditAddroject={handleEditAddroject}
          />
        )}
        {/* * add comment  modal S */}
        <div
          class="modal fade modal-lg"
          id="ct_add_comment_modal"
          tabindex="-1"
          aria-labelledby="ct_add_comment_modalLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "600px" }}
          >
            <div class="modal-content ct_p_30 ct_border_radius_20">
              <div class="modal-header border-0 p-0 ct_mb_30">
                <div>
                  <h4 class="mb-1 ct_fs_20">Add New Project</h4>
                  <p class="mb-0 ct_grey_text">
                    Leave a note or update for the enterprise client
                  </p>
                </div>
                <button
                  type="button"
                  class="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body p-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="ct_mb_20">
                      <ul>
                        <li className="d-flex align-items-center gap-3 mb-2">
                          <p className="mb-0 ct_fs_14 ct_white_nowrap">
                            Project:{" "}
                          </p>
                          <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                            Marketing Campaign - July
                          </p>
                        </li>
                        <li className="d-flex align-items-center gap-3 mb-2">
                          <p className="mb-0 ct_fs_14 ct_white_nowrap">
                            Enterprise Client :{" "}
                          </p>
                          <p className="mb-0 ct_fs_14 ct_para_scroll ct_custom_scroll">
                            {" "}
                            Acme Corporation
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div class="form-group ct_mb_20">
                      <label class="ct_fs_14 ct_darkblue_text mb-2">
                        Comment
                      </label>
                      <textarea
                        class="form-control ct_input h-auto ct_fs_12"
                        rows={4}
                        placeholder="Write your comment or update here...."
                      ></textarea>
                    </div>
                    <div class="form-group ct_mb_20">
                      <label class="ct_fs_14 ct_darkblue_text mb-2">
                        Attach File (Optional)
                      </label>
                      <div
                        class="ct_upload_product_main ct_upload_product_main_180 "
                        style={{ height: "118px" }}
                      >
                        <svg
                          width="33"
                          height="33"
                          viewBox="0 0 33 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.87174 22.0167C4.26376 20.9403 3.20508 19.1073 3.20508 17.027C3.20508 13.9023 5.59376 11.3354 8.64473 11.0528C9.26883 7.25653 12.5654 4.36035 16.5384 4.36035C20.5114 4.36035 23.808 7.25653 24.4321 11.0528C27.4831 11.3354 29.8717 13.9023 29.8717 17.027C29.8717 19.1073 28.8131 20.9403 27.2051 22.0167M11.2051 21.6937L16.5384 16.3604M16.5384 16.3604L21.8717 21.6937M16.5384 16.3604V28.3604"
                            stroke="#9CA3AF"
                            stroke-width="2.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                        <p class="text-center ct_fs_12 ct_text_op_07 mb-0">
                          Upload Screenshot/ PDF/ Design File
                        </p>
                        <label for="ct_upload_product">
                          <input
                            id="ct_upload_product"
                            class="d-none"
                            type="file"
                            name=""
                          />
                        </label>
                      </div>
                      <div class="ct_single_uploaded_img mt-3 d-none">
                        <img
                          alt=""
                          src="../assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                        />
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>

                    <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label for="" className="ct_text_clr_757886">
                        Notify Client Via Email
                      </label>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-3 justify-content-end ">
                  <button
                    data-bs-target="#add_new_project"
                    data-bs-toggle="modal"
                    class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                    type="button"
                  >
                    Previous
                  </button>
                  <button
                    class="ct_yellow_btn px-5 ct_h_44"
                    data-bs-target="#ct_project_success"
                    data-bs-toggle="modal"
                    type="button"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* add comment  modal E  */}

        {/* Project Upload Sucess Modal S */}
        <div
          class="modal fade ct_markas_complete_modal"
          id="ct_project_success"
          tabindex="-1"
          aria-labelledby="ct_project_successLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content ct_border_radius_20">
              <div class="modal-header border-0">
                <button
                  type="button"
                  class="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body pb-5 pt-0">
                <div class="mx-auto d-block text-center ct_mb_20">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div class="text-center">
                  <h4 class="ct_fs_18 ">Project Successful Sent</h4>
                  <p
                    className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                    style={{ maxWidth: "388px" }}
                  >
                    Project wil be reviewed after 24 hours
                  </p>
                </div>
                <div class="d-flex align-items-center gap-3 justify-content-center ct_mt_30 ">
                  <button
                    class="ct_yellow_btn px-5 ct_h_44 w-100"
                    type="button"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Project Upload Sucess Modal E */}

        {/* ct_Upload_Deliverable_modal modal S */}
        {/* <div
          class="modal fade modal-lg"
          id="ct_Upload_Deliverable_modal"
          tabindex="-1"
          aria-labelledby="ct_Upload_Deliverable_modalLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "700px" }}
          >
            <div class="modal-content ct_p_30 ct_border_radius_20">
              <div class="modal-header border-0 p-0 ct_mb_30">
                <div>
                  <h4 class="mb-1 ct_fs_20">Upload Deliverable</h4>
                  <p class="mb-0 ct_grey_text">
                    Submit completed work or progress files for the client to
                    review
                  </p>
                </div>
                <button
                  type="button"
                  class="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body p-0">
                <div className="row">
                  <div className="col-md-12">
                    <div class="form-group ct_mb_20">
                      <label class="ct_fs_14 ct_darkblue_text mb-2">
                        Upload Deliverable Files (2 max)
                      </label>
                      <div
                        class="ct_upload_product_main ct_upload_product_main_180 "
                        style={{ height: "118px" }}
                      >
                        <svg
                          width="33"
                          height="33"
                          viewBox="0 0 33 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.87174 22.0167C4.26376 20.9403 3.20508 19.1073 3.20508 17.027C3.20508 13.9023 5.59376 11.3354 8.64473 11.0528C9.26883 7.25653 12.5654 4.36035 16.5384 4.36035C20.5114 4.36035 23.808 7.25653 24.4321 11.0528C27.4831 11.3354 29.8717 13.9023 29.8717 17.027C29.8717 19.1073 28.8131 20.9403 27.2051 22.0167M11.2051 21.6937L16.5384 16.3604M16.5384 16.3604L21.8717 21.6937M16.5384 16.3604V28.3604"
                            stroke="#9CA3AF"
                            stroke-width="2.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                        <p class="text-center ct_fs_12 ct_text_op_07 mb-0">
                          Upload Your deliverable files
                        </p>
                        <label for="ct_upload_product">
                          <input
                            id="ct_upload_product"
                            class="d-none"
                            type="file"
                            name=""
                          />
                        </label>
                      </div>
                      <div class="ct_single_uploaded_img mt-3 d-none">
                        <img
                          alt=""
                          src="../assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                        />
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>
                    <div class="form-group ct_mb_20">
                      <label class="ct_fs_14 ct_darkblue_text mb-2">
                        Message to Client (Optional)
                      </label>
                      <textarea
                        class="form-control ct_input h-auto ct_fs_12"
                        rows={4}
                        placeholder="Write your comment or update here...."
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-3 justify-content-end ">
                  <button
                    class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    class="ct_yellow_btn px-5 ct_h_44"
                    data-bs-target="#ct_Upload_file_sucess"
                    data-bs-toggle="modal"
                    type="button"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* ct_Upload_Deliverable_modal modal E  */}

        {/* Project Upload Sucess Modal S */}

        {/* Project Upload Sucess Modal E */}
        {/* ct_project_marked_modal Modal S */}
        {/* <div
          class="modal fade ct_markas_complete_modal"
          id="ct_project_marked_modal"
          tabindex="-1"
        // aria-labelledby="ct_project_marked_modalLabel"
        // aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content ct_border_radius_20">
              <div class="modal-header border-0">
                <button
                  type="button"
                  class="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body pb-5 pt-0">
                <div class="mx-auto d-block text-center ct_mb_20">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div class="text-center">
                  <h4 class="ct_fs_18 ">Project Marked</h4>
                  <p
                    className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                    style={{ maxWidth: "388px" }}
                  >
                    Project marked as complete. Awaiting client review.
                  </p>
                </div>
                <div class=" ct_mt_30 w-100 ">
                  <button
                    class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44 w-100"
                    type="button"
                  // data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* Project Upload Sucess Modal E */}

        {/* File Upload Sucess S */}
        <div
          class="modal fade ct_markas_complete_modal"
          id="ct_Upload_file_sucess"
          tabindex="-1"
          aria-labelledby="ct_Upload_file_sucessLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content ct_border_radius_20">
              <div class="modal-header border-0">
                <button
                  type="button"
                  class="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body pb-5 pt-0">
                <div class="mx-auto d-block text-center ct_mb_20">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div class="text-center">
                  <h4 class="ct_fs_18 ct_darkblue_text ">Upload Successful</h4>
                  <p className="ct_fs-14 ct_grey_text mb-0 mx-auto">
                    Deliverable submitted to client successfully
                  </p>
                </div>
                <div class=" ct_mt_30 w-100 ">
                  <button
                    class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44 w-100"
                    type="button"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* File Upload Sucess E */}
        {/* File Upload Sucess S */}
        <div
          class="modal fade ct_markas_complete_modal"
          id="ct_comment_added_success"
          tabindex="-1"
          aria-labelledby="ct_comment_added_successLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content ct_border_radius_20">
              <div class="modal-header border-0">
                <button
                  type="button"
                  class="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body pb-5 pt-0">
                <div class="mx-auto d-block text-center ct_mb_20">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#FFB703"
                    />
                  </svg>
                </div>
                <div class="text-center">
                  <h4 class="ct_fs_18 ct_darkblue_text ">Comment Added</h4>
                  <p className="ct_fs-14 ct_grey_text mb-0 mx-auto">
                    Your Comment has been added to the project
                  </p>
                </div>
                <div class=" ct_mt_30 w-100 ">
                  <button
                    class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44 w-100"
                    type="button"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* File Upload Sucess E */}
      </HireTalentLayout>
    </div>
  );
};

export default MyProjects;
